import RouteNames from "@/entities/RouteNames";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import NavigationIcons from "@/entities/NavigationIcons";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import Roles from "@/entities/Roles";
import { newSchedulerInnerComponent } from "@/data/navigationComponents/newNavigationComponents";
import RouteWrapper from "@/components/common/RouteWrapper.vue";

const NewCompanyScheduler = () =>
  import("@/views/scheduler/NewCompanyScheduler.vue").then((m) => m.default);
const CompanySchedulerV2 = () =>
  import("@/views/schedulerV2/CompanyScheduler.vue").then((m) => m.default);

// Changed from getNewCompanySchedulerRoutes to getNewCompanyCalendarRoutes
const getNewCompanyCalendarRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/manage",
    component: RouteWrapper,
    meta: {
      title: "Calendar",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.MANAGE_COMPANIES,
        routeName: RouteNames.NEW_MANAGE_SCHEDULE,
        isStyled: true,
      },
    },
  },
]);

// Changed from getNewCompanyPrivateSchedulerRoutes to getNewCompanyPrivateCalendarRoutes
const getNewCompanyPrivateCalendarRoutes: GetRelativeRoutes = getChildRoutes([
  // {
  //     path: "new-scheduler",
  //     name: RouteNames.NEW_MANAGE_SCHEDULE,
  //     component: NewCompanyScheduler,
  //     meta: {
  //         title: Roles.ADMIN ? "Scheduler" : "My Scheduler",
  //         roles: [Roles.ADMIN, Roles.MANAGER],
  //         breadcrumb: {
  //             title: BreadcrumbsTitles.SCHEDULER,
  //             icon: NavigationIcons.SCHEDULE,
  //             routeName: RouteNames.NEW_MANAGE_SCHEDULE,
  //             innerComponent: newSchedulerInnerComponent,
  //         },
  //     },
  // },
  {
    path: "calendar",
    name: RouteNames.NEW_MANAGE_SCHEDULE,
    // name: "scheduler",
    component: CompanySchedulerV2,
    meta: {
      title: "Calendar",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: "Calendar",
        routeName: RouteNames.NEW_MANAGE_SCHEDULE,
        isStyled: true,
      },
    },
  },
]);

export { getNewCompanyCalendarRoutes, getNewCompanyPrivateCalendarRoutes };
